export * from './style-manager.component';